import makeUrl from '@/utils/makeUrl';
const memberApiPre = `/api/member`;
const memberApiList = [
	// 充值接口
	'recharge',
	// 充值金额列表
	'rechargeList',
	//充值限制
	'getCouponCountsByUCid',
	// 兑换码充值
	'rechargeCode',
	// 历史优惠券列表
	'couponHistory',
	// 发票列表
	'invoiceList',
	// 发票详情
	'invoiceDetail',
	// 可用优惠券列表
	'coupon',
	// 开票
	'addInvoice',
	//开票配置
	'invoiceParam',
	// 开票对应订单列表
	'invoiceOrderList',
	// 订单自提时间列表
	'getInvoiceMoney',
	// 收货地址列表
	'addressList',
	// 新增收货地址
	'addAddress',
	// 編輯地址詳情
	'addressDetail',
	// 绑定饭卡
	'bindCard',
	// 获取用户信息
	'getuserinfo',
	// 解绑饭卡
	'unbindCard',
	// 账户/卡支出明细
	'accountOutput',
	// 账户/卡收入明细
	'accountInput',
	// 账户列表（个人中心和订单支付入口两个用的同一个接口）
	'accountLog',
	// 饭卡流水
	'cardLogs',
	// 判断是否属于某个商务楼
    'addressType',
];
const memberApi = {};

memberApiList.forEach(key => {
	memberApi[`${key}Url`] = makeUrl(memberApiPre, key);
});

export default memberApi;